export const messages = {
  en: {
    goldBusinessManage: {
      queryConditions: 'Query Conditions',
      inputTransactionId: 'Please enter transaction ID',
      inputGoldAmount: 'Please enter gold amount',
      inputBuyerName: 'Please enter buyer name',
      query: 'Query',
      reset: 'Reset',
      purchaseRecords: 'Purchase Records',
      transactionId: 'Transaction ID',
      type: 'Type',
      amount: 'Amount',
      goldCount: 'Gold Count',
      goldType: 'Gold Type',
      transactionTime: 'Transaction Time',
      buyer: 'Buyer',
      remark: 'Remark'
    }
  },
  zh: {
    goldBusinessManage: {
      queryConditions: '查询条件',
      inputTransactionId: '请输入交易编号',
      inputGoldAmount: '请输入金币数量',
      inputBuyerName: '请输入购买人',
      query: '查询',
      reset: '重置',
      purchaseRecords: '购买记录',
      transactionId: '交易编号',
      type: '类型',
      amount: '金额',
      goldCount: '金币数量',
      goldType: '金币类型',
      transactionTime: '交易时间',
      buyer: '购买人',
      remark: '备注'
    }
  }
}